export const compareObjects = (a: any, b: any) => {
	if (a == null && b == null)
	{
		return true;
	}

	if (a == null || b == null)
	{
		return false;
	}

	let s = (o: any) => Object.entries(o).sort().map(i => {
		if (i[1] instanceof Object) i[1] = s(i[1]);
		return i
	})
	return JSON.stringify(s(a)) === JSON.stringify(s(b))
}